// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom_div[data-v-1eeecd26]{margin-bottom:.9375rem}.custom_div>span[data-v-1eeecd26]{font-size:.875rem;color:#444}", ""]);
// Exports
module.exports = exports;
